import React from 'react';
// import './App.css';
import { getCountry } from '../utils/dataService';
import {
  Select,
  MenuItem,
} from '@material-ui/core';

export default class SimpleSelect extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
      data: getCountry(),
      selected: 'IN'

     };

     // this.handleChange1 = this.handleChange1.bind(this)
  }

  handleChange = event => {
    this.setState({ selected: event.target.value, name: event.target.name});
  };
renderOptions() {
     return this.state.data.map((dt, i) => {
      //console.log(dt);
       return (
           <MenuItem
             label="Select a country"
             value={dt.country_code}
            key={i} name={dt.country_name}>{dt.country_name}</MenuItem>
         
       );
     });
    }
    render() {
      console.log(this.state.selected);
      return (
         <div className="padd50">
           <Select className="width50" value={this.state.selected} onChange={this.handleChange}>
             {this.renderOptions()}
           </Select>
<h3>Selected Country - {this.state.selected}</h3>
         </div>
      );
    }
}


// WEBPACK FOOTER //
// src/pages/SendMessage.js